const localPreview = ['localhost', '127.0.0.1'].includes(window.location.hostname);

// Public reads can use production locally without enabling live payment/admin writes.
export const PUBLIC_API_BASE = (
  process.env.REACT_APP_PUBLIC_API_BASE
  || (localPreview ? 'https://asia-south1-innoture-alc-trust.cloudfunctions.net/api' : process.env.REACT_APP_PAYMENT_API_BASE || '/api')
).replace(/\/$/, '');
